import { SalesActionEnum } from './sales-action-enum';

export class PriceComponentToSalesAction {
  priceComponentId: number = null;
  salesAction: SalesActionEnum = null;
}
